module.exports = __webpack_public_path__ + "media/images/webpage/shared/gototravel/bnr-gototravel-212f758d105d9d428f68bbb9491407e8.jpg";